export { Figure } from './Figure'
